export function finishLoading(): void {
  window.PMW.setLoading(null);
}
